<template>
  <div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <h5>
                    <i class="fa fa-clock-o"></i>
                    سجل تسجيل دخول المستخدمين والمشرفين لهذا الحساب
                </h5>
            </div>
            <div class="card-body">
                <div class="col-12 table-responsive">
                    <table class="table table-hover table-bordered table-sm">
                        <thead>
                            <th>
                                دخول الى
                            </th>
                            <th>
                                نوع الحساب
                            </th>
                            <th>
                                الاسم
                            </th>
                            <th>
                                اسم المستخدم
                            </th>
                            <th>
                                التاريخ
                            </th>
                            <th>
                                IP
                            </th>
                            <th>
                                الحالة
                            </th>
                            <th>
                                خيارات
                            </th>
                        </thead>
                        <tbody>
                            <tr v-for="session in sessions" :key="session._id">
                                <td>
                                    {{ session.from.replace("desktop", "جهاز مكتبي").replace("app", "تطبيق الجوال").replace("mobile", "جوال على المتصفح") }}
                                </td>
                                <td>
                                    {{ session.admin_id == "" ? 'المسؤول' : 'مشرف' }}
                                </td>
                                <td>
                                    {{ session.name }}
                                </td>
                                <td>
                                    {{ session.username }}
                                </td>
                                <td>
                                    {{ session.last_update }}
                                </td>
                                <td>
                                    {{ session.info.ip }}
                                </td>
                                <td>
                                    <span v-if="session.status == 0" class="text-warning">في الانتظار</span>
                                    <span v-if="session.status == 1" class="text-success">مقبول</span>
                                    <span v-if="session.status == 2" class="text-warning">مرفوض</span>
                                </td>
                                <td>
                                    <a v-if="session.status != 1" :href="api + '/general/session/' + session._id" target="_blank"><i class="fa fa-edit"></i> قبول/رفض</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {

            user: JSON.parse(localStorage.getItem('user')),
            sessions: [],
        }
    },
    created(){
        var g = this;
            $.post(api + '/user/auth/sessions', {
            jwt: this.user.jwt
        }).then(function(r){
            g.loading = false
            if(r.status != 100){
                alert(r.response, 200)
            }else{
                g.sessions = r.response
            }
        }).fail(function(){
            alert("حدث خطأ في الاتصال", 200)
        })
    }
}
</script>

<style>

</style>